import PaymentFilters from './SellPaymentFilters.container';

export default PaymentFilters;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/SellPaymentsPanel/SellPaymentsModal/SellPaymentFilters/index.js